import { Chip } from "@mui/material";
import { useRouterStore } from "../../../stores";

export const AppbarSection = ({open, width}:{open:boolean, width:string}) => {

  const section = useRouterStore((state) => state.section);
  if (!section) return null;
  
  return (
    <Chip
      title={section}
      color="secondary"
      size="medium"
      label={section}
      sx={{
        fontWeight: "bold",
        position: "absolute",
        right:open && width === "xs" ? "-20px" : "-80px", 
        top: "3px",
        minWidth: "80px",
      }}
    />
  );
};
